import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Router } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (localStorage.getItem('isLoggedin') == 'true') {
            return true;
        }else if (localStorage.getItem('isLoggedin') == 'false' || localStorage.getItem('isLoggedin') == undefined || localStorage.getItem('isLoggedin') == null) {
            localStorage.setItem('returnUrl', state.url);
            this.router.navigate(['/login']);
            return false;
        }
    }

    canActivateChild(){
        if (localStorage.getItem('isLoggedin') == 'true') {
            return true;
        }else if (localStorage.getItem('isLoggedin') == 'false' || localStorage.getItem('isLoggedin') == undefined || localStorage.getItem('isLoggedin') == null) {
            this.router.navigate(['/login']);
            return false;
        }
    }
}
